<template>
  <!--意见反馈-->
  <div>
    <div class="goods-head">
      <div class="slider-list">
        <div class="item selected">意见反馈</div>
      </div>
    </div>
    <section class="main">
      <article class="main-tab clearfloat">
        <div class="main-tab-title">反馈类型：</div>
        <div class="main-tab-con">
          <div class="main-tab-item" :class="[{'main-tab-item-xz':opinionData.feedbackType===1}]" @click="tab(1)">关于货源</div>
          <div class="main-tab-item" :class="[{'main-tab-item-xz':opinionData.feedbackType===2}]" @click="tab(2)">关于运力</div>
          <div class="main-tab-item" :class="[{'main-tab-item-xz':opinionData.feedbackType===3}]" @click="tab(3)">关于仓储</div>
          <div class="main-tab-item" :class="[{'main-tab-item-xz':opinionData.feedbackType===4}]" @click="tab(4)">关于订单</div>
          <div class="main-tab-item" :class="[{'main-tab-item-xz':opinionData.feedbackType===5}]" @click="tab(5)">其他</div>
        </div>
      </article>
      <el-form
        ref="opinion"
        class="opinion"
        :model="opinionData"
        :rules="rules"
        label-position="right"
        label-width="7rem"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item prop="feedbackContent" required>
              <el-input v-model="opinionData.feedbackContent" class="opinion-textarea" type="textarea" placeholder="请输入您在使用过程中遇到的问题（优质的提问，通常在20-100字之间哦）" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item prop="contact" required>
              <el-input v-model="opinionData.contact" class="opinion-contact" placeholder="请留下您的联系方式（手机号、QQ、邮箱）" />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="opinion-box clearfloat">
          <div class="opinion-release" @click="releaseClick(opinionData)">提交反馈</div>
          <!--<div class="opinion-cancel">取消</div>-->
        </div>
      </el-form>
    </section>
  </div>
</template>
<script>
import * as get from '@/api/personal/user/feedback/index.js' // 请求接口
export default {
  name: 'Feedback',
  data() {
    const checkContactWay = (rule, value, callback) => {
      const verify = /(^1[3456789]\d{9}$)|(^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9]{2,4})+$)/
      const verifying = /^[1-9]\d{4,9}$/
      if (value.match(verifying)) {
        callback()
      } else if (value.match(verify)) {
        callback()
      } else {
        callback(new Error('请输入有效的联系方式'))
      }
    }
    return {
      tabIndex: 1,
      // form 数据
      opinionData: {
        feedbackType: 1, // 反馈类型
        feedbackContent: '', // 反馈内容
        contact: '' // 联系方式
      },
      // 正则
      rules: {
        feedbackContent: [{ required: true, message: '必填' },
          { max: 200, message: '最多输入200个字符', trigger: 'blur' }
        ],
        contact: [{ required: true, message: '必填' },
          { max: 20, message: '最多输入20个字符', trigger: 'blur' },
          { validator: checkContactWay, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    tab(index) {
      this.opinionData.feedbackType = index
      this.opinionData.feedbackContent = ''
      this.opinionData.contact = ''
    },
    releaseClick(data) {
      this.$refs.opinion.validate((valid) => {
        if (valid) {
          get.releaseF(
            data
          ).then(res => {
            // this.opinionData.feedbackContent = ''
            // this.opinionData.contact = ''
            this.$message({
              message: '提交成功',
              type: 'success'
            })
          }).catch(error => {
            console.log(error)
          })
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
  $main-color: #be2316;
  .goods-head {
    padding: 12px 12px;
    box-sizing: border-box;
    border-style: solid;
    border-color: #f1f1f1;
    background-color: #ffffff;
    width: 928px;
    height: 50px;

    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      /*&::-moz-scrollbar {*/
      /*height: 0px !important;*/
      /*width: 0px !important;*/
      /*}*/
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;

        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
  }
  .main{
    min-height: 550px;
    border-color: #f1f1f1;
    background-color: #ffffff;
    padding: 40px 20px 50px 20px;
    .main-tab{
      .main-tab-title{
        float: left;
        width: 100px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        color: #333333;
        font-weight: bold;
      }
      .main-tab-con{
        float: left;
        .main-tab-item{
          float: left;
          width: 120px;
          height: 40px;
          line-height: 40px;
          margin-right: 20px;
          text-align: center;
          border: 1px solid #ADADAD;
          color: #555555;
          font-size: 14px;
          border-radius:4px;
          cursor: pointer;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          &.main-tab-item-xz{
            border: 1px solid #BE2316;
            color:#ffffff;
            background-color: #be2316;
          }
          &:last-child{
            margin-right: 0;
          }
        }
      }
    }
    .opinion-box{
      margin-top: 60px;
      .opinion-release{
        float: left;
        width: 136px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        background: #BE2316;
        border-radius: 4px;
        font-size: 18px;
        cursor: pointer;
        text-align: center;
        margin-left: 378px;
        /*margin: 0 auto;*/
      }
      .opinion-cancel{
        float: left;
        width: 136px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        background: #B3B3B3;
        border-radius: 4px;
        font-size: 18px;
        cursor: pointer;
        text-align: center;
        margin-left: 40px;
      }
    }
    /deep/.el-form-item__content{
      margin-left: 0 !important;
    }
      margin-left: 0px;
      .opinion-textarea{
        margin-top: 30px;
        /deep/.el-textarea__inner{
          height: 150px;
        }
      }

    .opinion-contact{
      margin-top: 30px;
    }
  }

</style>
